import { render, staticRenderFns } from "./ImportV2.vue?vue&type=template&id=a74c8988&scoped=true&"
import script from "./ImportV2.vue?vue&type=script&lang=js&"
export * from "./ImportV2.vue?vue&type=script&lang=js&"
import style0 from "./ImportV2.vue?vue&type=style&index=0&id=a74c8988&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74c8988",
  null
  
)

export default component.exports